import { render, staticRenderFns } from "./SetUpUpper18.vue?vue&type=template&id=4fd7d15f"
import script from "./SetUpUpper18.vue?vue&type=script&lang=js"
export * from "./SetUpUpper18.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports